var randomMax = function (max) {
  return Math.floor(Math.random() * max);
};

export { randomMax };
